import "../../styles/marquee.css"

import { StaticImage } from "gatsby-plugin-image"
import { useEffect, useRef, useState } from "react"
import rounded_left from "../../images/vectors/rounded-left.png"
import wave_right from "../../images/vectors/wave-right.png"

const cards = [
  {
    id: 1,
    image: (
      <StaticImage
        src="../../images/social-media-posts/1.png"
        alt="Post"
        placeholder="blurred"
      />
    ),
  },
  {
    id: 2,
    image: (
      <StaticImage
        src="../../images/social-media-posts/2.png"
        alt="Post"
        placeholder="blurred"
      />
    ),
  },
  {
    id: 3,
    image: (
      <StaticImage
        src="../../images/social-media-posts/3.png"
        alt="Post"
        placeholder="blurred"
      />
    ),
  },
  {
    id: 4,
    image: (
      <StaticImage
        src="../../images/social-media-posts/4.png"
        alt="Post"
        placeholder="blurred"
      />
    ),
  },
  {
    id: 5,
    image: (
      <StaticImage
        src="../../images/social-media-posts/5.png"
        alt="Post"
        placeholder="blurred"
      />
    ),
  },
  {
    id: 6,
    image: (
      <StaticImage
        src="../../images/social-media-posts/6.png"
        alt="Post"
        placeholder="blurred"
      />
    ),
  },
  {
    id: 7,
    image: (
      <StaticImage
        src="../../images/social-media-posts/7.png"
        alt="Post"
        placeholder="blurred"
      />
    ),
  },
  {
    id: 8,
    image: (
      <StaticImage
        src="../../images/social-media-posts/8.png"
        alt="Post"
        placeholder="blurred"
      />
    ),
  },
  {
    id: 9,
    image: (
      <StaticImage
        src="../../images/social-media-posts/9.png"
        alt="Post"
        placeholder="blurred"
      />
    ),
  },
  {
    id: 10,
    image: (
      <StaticImage
        src="../../images/social-media-posts/10.png"
        alt="Post"
        placeholder="blurred"
      />
    ),
  },
  {
    id: 11,
    image: (
      <StaticImage
        src="../../images/social-media-posts/11.png"
        alt="Post"
        placeholder="blurred"
      />
    ),
  },
  {
    id: 12,
    image: (
      <StaticImage
        src="../../images/social-media-posts/12.png"
        alt="Post"
        placeholder="blurred"
      />
    ),
  },
  {
    id: 13,
    image: (
      <StaticImage
        src="../../images/social-media-posts/13.png"
        alt="Post"
        placeholder="blurred"
      />
    ),
  },
  {
    id: 14,
    image: (
      <StaticImage
        src="../../images/social-media-posts/14.png"
        alt="Post"
        placeholder="blurred"
      />
    ),
  },
  {
    id: 15,
    image: (
      <StaticImage
        src="../../images/social-media-posts/15.png"
        alt="Post"
        placeholder="blurred"
      />
    ),
  },
  {
    id: 16,
    image: (
      <StaticImage
        src="../../images/social-media-posts/16.png"
        alt="Post"
        placeholder="blurred"
      />
    ),
  },
  {
    id: 17,
    image: (
      <StaticImage
        src="../../images/social-media-posts/17.png"
        alt="Post"
        placeholder="blurred"
      />
    ),
  },
  {
    id: 18,
    image: (
      <StaticImage
        src="../../images/social-media-posts/18.png"
        alt="Post"
        placeholder="blurred"
      />
    ),
  },
  {
    id: 19,
    image: (
      <StaticImage
        src="../../images/social-media-posts/19.png"
        alt="Post"
        placeholder="blurred"
      />
    ),
  },
  {
    id: 20,
    image: (
      <StaticImage
        src="../../images/social-media-posts/20.png"
        alt="Post"
        placeholder="blurred"
      />
    ),
  },
  {
    id: 21,
    image: (
      <StaticImage
        src="../../images/social-media-posts/21.png"
        alt="Post"
        placeholder="blurred"
      />
    ),
  },
]

const LinkedInCard = ({ card, index }) => {
  const isOdd = index % 2 !== 0

  return (
    <div
      className={`w-[280px] md:w-[380px] rounded-2xl overflow-hidden ${
        isOdd ? "mt-[60px]" : ""
      }`}
    >
      {card.image}
    </div>
  )
}

export default function AttendeeVoices() {
  const sectionRef = useRef<HTMLElement>(null)
  const [inView, setInView] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setInView(true)
          observer.disconnect()
        }
      },
      { threshold: 0.1 }
    )
    if (sectionRef.current) observer.observe(sectionRef.current)
    return () => observer.disconnect()
  }, [])

  return (
    <section ref={sectionRef} className="relative overflow-hidden py-12 md:py-20 bg-[#F3EDFF]">
      <div className="text-center mb-16 px-6">
        <h2 className="text-[34px] md:text-5xl lg:text-6xl font-semibold text-black mb-5">
          Attendee Voices
        </h2>

        <p className="text-gray-900 text-base md:text-lg max-w-lg mx-auto leading-relaxed">
          When your attendees get talking, organic reach becomes your most
          powerful marketing engine
        </p>
      </div>

      <div className="marquee-wrapper relative z-40">
        <div className="marquee-track" style={{ animationPlayState: inView ? "running" : "paused" }}>
          {[...cards, ...cards].map((card, idx) => (
            <div key={idx} className="marquee-item">
              <LinkedInCard card={card} index={idx % cards.length} />
            </div>
          ))}
        </div>
      </div>

      {/* Background vectors */}
      <div className="absolute top-[10%] -left-4 z-4">
        <img src={rounded_left} alt="Vector" width={500} />
      </div>

      <div className="absolute top-[10%] right-0 z-4">
        <img src={wave_right} alt="Vector" width={500} />
      </div>
    </section>
  )
}
